module.exports = __webpack_public_path__ + "static/beypilic-fe31142b6e1449ecc45f4a7263ff43d1.png";